module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Confidențialitate",
	"footer.privacy.url": "https://www.grohe.ro/ro_ro/compania/confidentialitate.html",
	"footer.disclaimer.text": "Informații juridice",
	"footer.disclaimer.url": "https://www.grohe.ro/ro_ro/compania/informatii-juridice.html",
	"footer.copyright": "&copy; 2018 GROHE AG",
	"homepage.headline": "Configuratorul Sisteme Pentru Apă GROHE",
	"homepage.introtext": "Răspunde doar la câteva întrebări de mai jos pentru a configura sistemul pentru apă GROHE care se va potrivi perfect nevoilor tale.",
	"homepage.buttonStart": "Începe",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 Pagina nu a fost găsită",
	"404.link.goBack": "Înapoi la pagina de pornire",
	"configurator.button.seeResults": "Vezi rezultatele",
	"question1.question": "Ai o sursă de apă rece și caldă în bucătăria ta?",
	"question1.option1.text": "Da, am o sursă de apă rece și caldă în bucătăria mea",
	"question1.option2.text": "Am doar o sursă de apă rece în bucătărie",
	"question2.question": "Ce tip de apă dorești?",
	"question2.option1.text": "Apă fierbinte pentru prepararea alimentelor și a băuturilor",
	"question2.option2.text": "Apă răcită și carbogazoasă pentru băut",
	"question2.option3.text": "Apă răcită și carbogazoasă, precum și apă caldă fierbinte",
	"question3.question": "Dorești să menții robinetul de bucătărie existent?",
	"question3.option1.text": "Vreau să-l păstrez",
	"question3.option2.text": "Vreau să instalez un model nou",
	"question4.question": "Care ar trebui să fie bateria de bucătărie principală?",
	"question4.option1.text": "GROHE Blue Home",
	"question4.option2.text": "GROHE Red",
	"question5.question": "Care este designul tău preferat pentru pipa bateriei?",
	"question5.option1.text": "Pipă formă L",
	"question5.option2.text": "Pipă formă U",
	"question5.option3.text": "Pipă formă C",
	"question6.question": "What's your prefered spout design for the GROHE Red Mono tap?",
	"question6.option1.text": "L-shaped spout",
	"question6.option2.text": "C-shaped spout",
	"question7.question": "Care este finisajul tău preferat?",
	"question7.option1.text": "Cromat",
	"question7.option2.text": "Supersteel",
	"question8.question": "Care să fie capacitatea boilerului de care ai nevoie?",
	"question8.option1.text": "Mărime M (3 litri)",
	"question8.option2.text": "Mărime L (5.5 litri)",
	"question9.question": "Would you like to have an additional filter to soften and enhance the water?",
	"question9.option1.text": "Yes",
	"question9.option2.text": "No",
	"results.title": "{productGroupsCount, plural, \none {Rezultatul tău} \nother {Rezultatele tale}\n}",
	"results.proposal.title": "Proposal {number}",
	"results.proposal.title.single": "Proposal",
	"results.bundle.title": "Pentru o instalare corectă vei avea nevoie și de:",
	"results.newConfiguration.title": "Dorești să configurezi un nou sistem pentru apă?",
	"results.newConfiguration.buttonText": "Configurează un nou sistem pentru apă",
	"results.product.number": "Codul produsului: #{number}",
	"results.product.button.productInformation": "Informații despre produs",
	"results.product.button.dealerLocator": "Caută un showroom",
	"results.product.button.buyNow": "Buy Now",
	"results.product.button.downloadPDF": "Download PDF",
	"results.product.information": "Informații despre produs",
	"results.product.dealer": "Caută un showroom",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now"
};


//////////////////
// WEBPACK FOOTER
// ./src/translations/water.ro_ro.json
// module id = 785
// module chunks = 0